import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import styles from './KioskFeedbackLayout.styles';
import { connect } from 'react-redux';
// import { Paper } from '@material-ui/core';
// import EventLogHandler from '../Common/event-log-handler';
//import { readSettings } from '../../helpers/board';
import { readKioskSettings } from '../Common/skipSteps';
import step from '../Common/show_hide_steps';
import allApiCall from '../Common/allApiCall';
import {
  KioskFooter,
  KioskHeader,
  KioskFeedbackMain,
  KioskIdelScreen
} from '..';
import KioskTouchSound from '../Kiosk/TouchSound';
let FileObje = null;
export class KioskFeedbackLayout extends Component {
  constructor(props) {
    super(props);
    FileObje = readKioskSettings(2);
    if (FileObje !== null) {
      let index = FileObje.steps.findIndex(x => x.value === false);
      if (index > -1) {
        let res = FileObje.steps.filter(x => x.step === step.step8);
        res = res[0];
        if (res.value === false) {
          allApiCall(FileObje, this.props);
          this.props.history.push(res.next);
          this.props.history.push(res.next);
        }
      }
    }
  }
  static propTypes = {
    test: PropTypes.string
  };
  playTouchSound = () => {
    //e.preventDefault();
    let sound = document.getElementById('touchSound');
    sound.play();
  };

  componentDidMount() {
    let index = FileObje.steps.findIndex(
      x => x.step === step.step8 && x.value === true
    );
    if (index > -1) {
      allApiCall(FileObje, this.props);
    }
  }
  handleClick = () => {
    this.playTouchSound();
    setTimeout(() => {
      localStorage.setItem('Paymentreceived', false);
      this.props.history.push('/');
      this.props.history.push('/');
    }, 30);
  };

  render() {
    const { classes, requestPayloads } = this.props;
    return (
      <div
        onClick={() => {
          this.playTouchSound();
        }}
        className={classNames(classes.container)}
      >
        <KioskHeader />
        <KioskFeedbackMain
          handleClick={this.handleClick}
          requestPayloads={requestPayloads}
        />
        <KioskFooter customFooterBottom={'0%'} isLanguageBarAllowd={true} />
        <KioskIdelScreen />
        <KioskTouchSound />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const kiosk =
    // state.get('kiosk') && state.get('kiosk').toJS && state.get('kiosk').toJS();
    state.get('kiosk');
  return {
    ...kiosk
  };
};

const KioskFeedbackContainer = connect(
  mapStateToProps,
  null
)(KioskFeedbackLayout);

export default withStyles(styles, { withTheme: true })(
  withRouter(KioskFeedbackContainer)
);
